<div class="slider-trigger-track"
  [class.loading]="loading"
  [class.disabled]="disabled"
  tidyMultiClick="10" delay="5000" (onMultiClick)="onMultiClick()">

  <div class="slider-trigger-fill" [style.width.%]="fillPercent"></div>

  <div class="slider-trigger-thumb"
    [style.left]="thumbLeft"
    [class.pulse]="!loading && value === 0"
    (touchstart)="onTouchStart($event)"
    (mousedown)="onMouseDown($event)">
    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>
    <svg *ngIf="!loading" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  </div>

  <span class="slider-trigger-label" *ngIf="!loading">
    <span class="slider-trigger-chevrons">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </span>
    {{label}}
  </span>
</div>
